// extracted by css-extract-rspack-plugin
export default {"root":"I02Whqqrzm0UGBit","fadeIn":"k42_EIrgWS0dqS8J","icon":"aX4CFXAnyegQO44n"};